import { render, staticRenderFns } from "./iconDelete.vue?vue&type=template&id=77054397&"
import script from "./iconDelete.vue?vue&type=script&lang=js&"
export * from "./iconDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports